<template>
  <div class="rc-rich-box-runtime" :class="getClassByCopy">
    <el-form-item :prop="getProp" label-width="none" :rules="rules" ref="formItem" :class="{'to-left':component.properties.sortType==='toLeft','hidden':component.properties.sortType==='hidden'}">
      <span class="rc-rich-box-name"><i class="required" v-show="component.properties.required">*</i>{{component.name}}</span>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <div class="editor" :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}" ref="editor"></div>
    </el-form-item>
  </div>
</template>

<script>
import { componentMixin, inputMixin, relFunMixin, uploadMixin } from './mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
import Editor from 'wangeditor'
import tokenStorage from '@/plugins/tokenStorage'
export default {
  name: 'rc-rich-box',
  mixins: [ componentMixin, inputMixin, relFunMixin, heightMixin, uploadMixin ],
  props: ['component', 'value', 'index', 'disabled'],
  inject: ['initState', 'initCount'],
  data () {
    return {
      editor: undefined
    }
  },
  mounted () {
    this.initRichBox()
    this.initHeight(this.$refs.editor.children[1])
    // 富文框允许拖入事件
    this.initDragEvent('editor')
    if (this.disabled) {
      this.editor.$textElem.attr('contenteditable', false)
      this.$refs.editor.querySelector('.w-e-toolbar').style.display = 'none'
      this.$refs.editor.querySelector('.w-e-text-container').style.borderTop = '1px solid #ccc'
      if (this.component.properties.heightAdaptation) {
        this.$refs.editor.querySelector('.w-e-text-container').style.height = 'auto'
      }
    }
  },
  beforeDestroy () {
    this.destroyDragEvent('editor')
  },
  watch: {
    'initState.state' (val) {
      if (val) {
        this.setRichValue()
      }
    },
    'initCount.value' (val) {
      if (val > 0) {
        this.editor.txt.html('')
      }
    }
  },
  methods: {
    initComponent () {
      this.editor.$textElem.attr('contenteditable', true)
    },
    initRichBox () {
      let self = this
      let token = tokenStorage.getToken()
      this.editor = new Editor(this.$refs.editor)
      this.editor.customConfig.showLinkImg = false
      this.editor.customConfig.zIndex = 100
      this.editor.customConfig.uploadImgTimeout = 30000
      // 自定义处理粘贴的文本内容
      this.editor.customConfig.pasteTextHandle = function (content) {
        // 设置了禁止粘贴
        if (self.component.properties.disablePaste) return ''
        // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        if (content === '' && !content) return ''
        let str = content
        // 处理的标签里的多余代码
        str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
        str = str.replace('/(\\n|\\r| class=(")?Mso[a-zA-Z]+(")?)/g', '')
        let reg = new RegExp('<!--(.*?)-->', 'g')
        str = str.replace(reg, '')
        return str
      }
      // 定义图片接受file name 名称后台定义的file
      this.editor.customConfig.uploadFileName = 'image'
      this.editor.customConfig.uploadImgHeaders = {
        'Authorization': token
      }
      this.editor.customConfig.uploadImgServer = `/shared-api/files/uploadImage`
      this.editor.customConfig.uploadImgParams = {type: 'USER'}
      this.editor.customConfig.uploadImgHooks = {
        error (xhr, editor) {
          this.$message.error('上传失败')
        },
        customInsert (insertImg, result, editor) {
          let url = self.getDownLoadUrl(result.data)
          insertImg(url)
        }
      }
      this.editor.customConfig.onchange = html => {
        this.update(html)
        this.$nextTick(() => {
          this.$refs.formItem.validate('change')
          this.executeFunctions('change')
        })
      }
      this.editor.customConfig.onfocus = () => {
        self.executeFunctions('focus')
      }
      this.editor.create()
    },
    setRichValue () {
      if (this.value) {
        this.editor.txt.html(this.value)
      }
    },
    getDownLoadUrl (path) {
      return sessionStorage.getItem('ossDownloadUrl') + path
    }
  }
}
</script>
<style lang="scss">
 .layout-form .list-component-item .rc-rich-box-runtime {
    height: 100%;
    >.el-form-item{
      height: 100%;
      .rc-rich-box-name {
        padding-left: 0px;
        .required {
          color: #F56C6C;
          position: absolute;
          left: -1px;
          top: -4px;
        }
      }
      .el-form-item__content {
        padding-left: 2px;
      }
      >.el-form-item__content{
        height: 100%;
      }
    }
    .editor {
      height: 100%;
      color: #000;
      .w-e-toolbar {
        display: block;
        background: #fff !important;
        border:1px solid #f1f1f1 !important;
        padding: 0;
        .w-e-menu {
          display: inline-block;
        }
      }
      /*.w-e-text-container {*/
      /*border:1px solid #f1f1f1 !important;*/
      /*}*/
      .w-e-text {
        background: #fff;
        p {
          margin: 0;
          padding: 0;
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-rich-box.vue